import { render, staticRenderFns } from "./ForEmployersSignUp.vue?vue&type=template&id=6a453476&"
import script from "./ForEmployersSignUp.vue?vue&type=script&lang=js&"
export * from "./ForEmployersSignUp.vue?vue&type=script&lang=js&"
import style0 from "./ForEmployersSignUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports